import styled, { css } from 'styled-components';

type AnimationTiming = {
  $animationKey: string;
  $duration: number /* in ms */;
  $transitionToIncrement: number /* in % */;
  $transitionToIncrementDone: number /* in % */;
  $transitionToEnd: number /* in % */;
  $transitionToEndDone: number /* in % */;
};

export const animationTimingForAllStages: AnimationTiming = {
  $animationKey: 'numberIncrement3',
  $duration: 3000,
  $transitionToIncrement: 40,
  $transitionToIncrementDone: 50,
  $transitionToEnd: 90,
  $transitionToEndDone: 100,
};

export const animationTimingWithoutStartStage: AnimationTiming = {
  $animationKey: 'numberIncrement2',
  $duration: 1500,
  $transitionToIncrement: 0,
  $transitionToIncrementDone: 0,
  $transitionToEnd: 80,
  $transitionToEndDone: 100,
};

export const Container = styled.div(
  () => css`
    position: relative;
  `,
);

export const DisabledStage = styled.div(() => css``);

export const StartStage = styled.div<AnimationTiming>(
  ({ $animationKey, $duration, $transitionToIncrement, $transitionToIncrementDone }) => css`
    @keyframes ${$animationKey}_startStage {
      0% {
        opacity: 1;
        position: static;
      }

      ${$transitionToIncrement}% {
        opacity: 1;
        position: static;
      }

      ${$transitionToIncrementDone - 1}% {
        opacity: 0;
        position: static;
      }

      ${$transitionToIncrementDone}% {
        opacity: 0;
        position: absolute;
        top: 0;
      }

      100% {
        opacity: 0;
        position: absolute;
        top: 0;
      }
    }

    animation-name: ${$animationKey}_startStage;
    animation-duration: ${$duration}ms;
    animation-timing-function: ease-out;
    opacity: 0;
    position: absolute;
    top: 0;
  `,
);

export const IncrementStage = styled.div<AnimationTiming>(
  ({
    $animationKey,
    $duration,
    $transitionToIncrement,
    $transitionToIncrementDone,
    $transitionToEnd,
    $transitionToEndDone,
  }) => css`
    @keyframes ${$animationKey}_incrementStage {
      0% {
        opacity: 0;
        position: absolute;
        top: 0;
      }

      ${$transitionToIncrement - 1}% {
        opacity: 0;
        position: absolute;
        top: 0;
      }

      ${$transitionToIncrement}% {
        opacity: 1;
        position: absolute;
        top: 0;
      }

      ${$transitionToIncrementDone - 1}% {
        opacity: 1;
        position: absolute;
        top: 0;
      }

      ${$transitionToIncrementDone}% {
        opacity: 1;
        position: static;
      }

      ${$transitionToEnd}% {
        opacity: 1;
        position: static;
      }

      ${$transitionToEndDone}% {
        opacity: 0;
        position: absolute;
        top: 0;
      }

      100% {
        opacity: 0;
        position: absolute;
        top: 0;
      }
    }

    animation-name: ${$animationKey}_incrementStage;
    animation-duration: ${$duration}ms;
    animation-timing-function: ease-out;
    opacity: 0;
    position: absolute;
    top: 0;
  `,
);

export const EndStage = styled.div<AnimationTiming>(
  ({ $animationKey, $duration, $transitionToEnd, $transitionToEndDone }) => css`
    @keyframes ${$animationKey}_endStage {
      0% {
        opacity: 0;
        position: absolute;
        top: 0;
      }

      ${$transitionToEnd - 1}% {
        opacity: 0;
        position: absolute;
        top: 0;
      }

      ${$transitionToEnd}% {
        opacity: 1;
        position: absolute;
        top: 0;
      }

      ${$transitionToEndDone}% {
        opacity: 1;
      }

      100% {
        opacity: 1;
      }
    }

    animation-name: ${$animationKey}_endStage;
    animation-duration: ${$duration}ms;
    animation-timing-function: ease-out;
    opacity: 1;
  `,
);
